<template>
  <Popver v-model="showPopver" :closeOnClickModal="false">
    <div class="slide-verify-wrapper">
      <div class="slide-bar" id="captcha"></div>
    </div>
  </Popver>
</template>

<script>
import Popver from "../Popver"
import { mapGetters, mapMutations } from "vuex"

export default {
  name: "slideVerify",
  methods: {
    ...mapMutations({
      handleToggleSlideVerify: "slideVerify/handleToggleSlideVerify"
    })
  },
  components: {
    Popver
  },
  computed: {
    ...mapGetters({
      showSlideVerify: "slideVerify/showSlideVerify"
    }),
    showPopver: {
      get() {
        return this.showSlideVerify
      },
      set(value) {
        this.handleToggleSlideVerify({ status: value })
      }
    }
  }
}
</script>

<style lang="scss" scoped>
.slide-verify-wrapper {
  background: #ffffff;
  min-height: 2rem;
  display: flex;
  align-items: center;
  justify-content: center;
  .slide-bar {
    width: 100%;
    min-height: 52px;
  }
}
</style>
